<template>
    <div class="form-elements">
        <div class="row" v-show="!download.load">
            <div class="form-group">
                <div class="col-md-6">
                    <input type="date" id='dia-inicio_2'>
                </div>
                <div class="col-md-6">
                    <input type="date" id='dia-fim_2'>
                </div>
            </div>
            <div class="form-group">
                <div class="col-md-12">
                    <button @click="getAulasTeoricas()" class="btn btn-primary btn-micro">Gerar Relatório</button>
                </div>
            </div>
        </div>
        <div v-show="download.load">
            <span>Pode demorar um pouco...</span>
            <div class="d-flex justify-content-center">
                <div class="btn-toolbar  d-inline-flex" role="toolbar" aria-label="Toolbar with button groups">
                    <component :animation-duration="1000" :is="'SpringSpinner'" :color="'#4AE387'" :size="80">
                    </component>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import * as spinners from "epic-spinners"
import urlApiV2 from '../../../../router/urlApiV2'

export default {
    name: "relatorioAulasTeoricas",
    components: {
        ...spinners,
    },
    data() {
        return {
            download: {
                load: false
            },
        }
    },
    methods: {
        getAulasTeoricas() {
            this.download.load = true

            let diaInicial = document.getElementById('dia-inicio_2').value
            let diaFinal = document.getElementById('dia-fim_2').value

            const params = {
                data_i: diaInicial,
                data_f: diaFinal,
            }

            this.$http.get(`${urlApiV2}/aulas/teoricas/relatorio/teoricas-pendentes`, {
                params,
            })
                .then(this.downloadCSV)
                .catch((err) => {
                    this.$toasted.show(err.body.data, { position: 'top-right' })
                })
                .finally(() => {
                    this.download.load = false
                })
        },
        downloadCSV(response) {
            let pdf = "data:application/octet-stream;base64," + response.body.data;
            let downloadPDF = document.getElementById("downloadPDF");
            downloadPDF.download = "relatorio-aulas-teoricas-com-pendencias.pdf";
            downloadPDF.href = pdf;
            downloadPDF.click();
            this.download.load = false;
        },

    },
}
</script>

<style></style>